/**
 * @file _initialize/_scroll-initialize.js
 */
(function($){
'use strict';
	var ApplyClass	= require('../_util/_apply-class');
	var Scroll		= require('../_view/_scroll.js');

	/**
	 * 初期化
	 */
	 var ScrollInitialize = function() {
	 	$(function() {
	 		applyClass();
	 	});
	 };

	 var applyClass = function() {
	 	 $('a[href^="#"]').each(function(idx, e){
	 		var $e = $(e);
	 		ApplyClass.apply(Scroll, $e, [$e]);
	 	});
	 };

	 module.exports = ScrollInitialize;
})(jQuery);